<script>
	import { isPortraitScreen, pageOffset, logoDone } from '../js/model/stores';
	import { animateElement } from '../js/utils/animate';
	import Arrow from ".././components/Arrow.svelte";
	import Subline from ".././components/Subline.svelte";

	export let hideHeadline = true;
	export let hideSubline = true;
	export let hideZero = true;
	export let hideFive = true;
	export let drawFive = false;
	export let rotate = false;

	let _scene;
	let _heart;
	let _leftTwo;
	let _rightTwo;
	let _duration = 180; // in frames at 60fps
	let _currentTime = 0; // frames

	let portrait;

	let animate = () => {
		_currentTime++;

		switch (_currentTime) {
			case 10:
				_heart.style.opacity = 1;
				break;
			case 50:
				_leftTwo.style.transform = 'rotateY(0deg) translateX(0px)';
				break;
			case 64:
				_leftTwo.style.transform = 'rotateY(0deg) translateX(-150px)';
				break;
			case 75:
				_leftTwo.style.fill = '#22398E';
				_rightTwo.style.fill = '#22398E';
				break;
			case 90:
				hideZero = false;
				rotate = true;
				break;
			case 100:
				drawFive = true;
				hideFive = false;
				break;
			case 120:
				hideHeadline = false;
				break;
			case 140:
				hideSubline = false;
				logoDone.set(true);
				break;
		}

		// Stop animation
		if (_currentTime > _duration) {
			return;
		}

		requestAnimationFrame(animate);
	};

	let prepareScene = () => {
		if (!_scene || !_heart) {

			requestAnimationFrame(animate);
		}

		isPortraitScreen.subscribe((state) => {
			portrait = state;
		});
	};

	prepareScene();

</script>
<style global>

	div {
		position: relative;
		top: 13%;
		margin: 0 auto;
		width: fit-content;
	}

	div.portrait {
		top: 20%;
	}

	svg {
		perspective: 25em;
		overflow: initial;
		width: 14em;
		height: auto;
	}

	.portrait svg {
		width: 10em;
	}

	#heart {
		opacity: 0;
		transition: opacity 0.5s;
	}

	.alpha-transition {
		opacity: 1;
		transition: opacity 1s;
	}

	#left_2 {
		transform-style: preserve-3d;
		transform-box: fill-box;
		transform: rotateY(-180deg) translateX(8px);
		transform-origin: center left;
		fill: #22398E;
		transition: transform 1s, fill 1s;
	}

	#right_2 {
		fill: #22398E;
		transition: fill 1s;
	}

	#five * {
		stroke: #22398E;
		stroke-width: 51px;
		stroke-linejoin: miter;
		stroke-linecap: butt;
		stroke-dasharray: 1000;
		stroke-dashoffset: 1000;
	}

	.hideHeadline {
		opacity: 0;
	}
	.hideSubline {
		opacity: 0;
	}
	.hideZero {
		opacity: 0;
	}
	.hideFive {
		opacity: 0;
	}

	.rotation {
		transition: transform 1s;
		transform-origin: 50% 50%;
		transform-box: fill-box;
	}
	.rotation--clockwise {
		transition: transform 1.5s;
		transform-origin: 55% 50%;
		transform: rotateZ(-270deg);
	}
	.rotation--reverseclockwise {
		 transform: rotateZ(180deg);
	}
	.rotate {
		transform: rotateZ(0deg);
	}

	.drawFive {
		animation-name: drawStroke;
        animation-duration: 2s;
        animation-fill-mode: forwards;
	}

	@keyframes drawStroke {
		0%   { stroke-dashoffset: 1000; }
		100% { stroke-dashoffset: 0; }
	}

</style>

<svelte:head>
<title>Chemnitz 2025</title>
</svelte:head>

<div class:portrait>
	<svg bind:this={_scene} width="300" height="369" viewBox="0 0 300 369" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g id="heart" bind:this={_heart}>
			<path id="right_2" bind:this={_rightTwo} d="M149 77.9892C159.9 73.8892 171.4 72.2892 182.6 73.2892C204 74.9892 224.6 85.4892 238.4 104.089C248 116.889 253 131.589 253.7 146.389H253.6C254.8 171.289 244 196.289 222.5 212.289C222.5 212.289 217.9 215.789 210.9 220.989C193.3 234.289 160.8 258.689 149.1 266.889V202.989L192.3 170.989C192.6 170.689 193 170.489 193.3 170.189C193.3 170.189 193.3 170.189 193.3 170.089C203.9 161.189 205.7 145.389 196.9 134.389C192 128.189 184.7 125.089 177.2 124.989C171.4 124.989 165.6 126.789 160.7 130.489L149.2 139.089V138.989L149.1 139.089V77.9892H149Z" fill="#22398E"/>
			<path id="left_2" bind:this={_leftTwo} d="M149 77.9892C159.9 73.8892 171.4 72.2892 182.6 73.2892C204 74.9892 224.6 85.4892 238.4 104.089C248 116.889 253 131.589 253.7 146.389H253.6C254.8 171.289 244 196.289 222.5 212.289C222.5 212.289 217.9 215.789 210.9 220.989C193.3 234.289 160.8 258.689 149.1 266.889V202.989L192.3 170.989C192.6 170.689 193 170.489 193.3 170.189C193.3 170.189 193.3 170.189 193.3 170.089C203.9 161.189 205.7 145.389 196.9 134.389C192 128.189 184.7 125.089 177.2 124.989C171.4 124.989 165.6 126.789 160.7 130.489L149.2 139.089V138.989L149.1 139.089V77.9892H149Z" fill="#22398E"/>
		</g>
		<g>
			<g class="alpha-transition" class:hideSubline id="sl">
				<path id="Vector" d="M6.53814 322.748H7.51412L10.7424 315.241H17.4241L12.6943 325.451L18.4751 336.187H11.7934L7.7018 328.266H6.53814V336.187H0.156738V315.241H6.53814V322.748Z" fill="#22398E"/>
				<path id="Vector_2" d="M26.1329 329.167C26.1329 330.218 26.9587 331.007 28.0848 331.007C29.2109 331.007 30.0368 330.218 30.0368 329.167V315.241H36.4182V329.655C36.4182 333.484 32.7395 336.487 28.0848 336.487C23.4302 336.487 19.7515 333.446 19.7515 329.655V315.241H26.1329V329.167Z" fill="#22398E"/>
				<path id="Vector_3" d="M40.6221 315.241H47.041V330.669H54.2482V336.187H40.6221V315.241Z" fill="#22398E"/>
				<path id="Vector_4" d="M58.2274 320.759H53.5728V315.241H69.2635V320.759H64.6088V336.187H58.2274V320.759Z" fill="#22398E"/>
				<path id="Vector_5" d="M77.8221 329.167C77.8221 330.218 78.6479 331.007 79.774 331.007C80.9002 331.007 81.726 330.218 81.726 329.167V315.241H88.1074V329.655C88.1074 333.484 84.4287 336.487 79.774 336.487C75.1194 336.487 71.4407 333.446 71.4407 329.655V315.241H77.8221V329.167Z" fill="#22398E"/>
				<path id="Vector_6" d="M98.6174 329.168V336.15H92.3486V315.204H100.795C105.036 315.204 108.34 318.056 108.34 322.186C108.34 324.776 107.026 326.878 105.036 328.079L109.015 336.15H102.146L99.0679 329.168H98.6174ZM99.8937 324.776C101.132 324.776 102.071 323.837 102.071 322.448C102.071 321.059 101.132 320.121 99.8937 320.121H98.6174V324.776H99.8937Z" fill="#22398E"/>
				<path id="Vector_7" d="M111.943 315.241H118.325V322.898H122.979V315.241H129.398V336.187H122.979V328.416H118.325V336.187H111.943V315.241Z" fill="#22398E"/>
				<path id="Vector_8" d="M145.277 315.241L152.109 336.187H145.577L144.601 332.508H139.008L138.07 336.187H131.538L138.37 315.241H145.277ZM140.21 327.778H143.363L141.786 321.81L140.21 327.778Z" fill="#22398E"/>
				<path id="Vector_9" d="M160.105 329.167C160.105 330.218 160.93 331.007 162.057 331.007C163.183 331.007 164.008 330.218 164.008 329.167V315.241H170.39V329.655C170.39 333.484 166.711 336.487 162.057 336.487C157.402 336.487 153.723 333.446 153.723 329.655V315.241H160.105V329.167Z" fill="#22398E"/>
				<path id="Vector_10" d="M181.013 329.768V336.15H174.631V315.204H183.077C187.356 315.204 190.622 318.357 190.622 322.486C190.622 326.615 187.356 329.768 183.077 329.768H181.013ZM182.101 324.926C183.415 324.926 184.353 323.912 184.353 322.486C184.353 321.097 183.415 320.084 182.101 320.084H181.013V324.926H182.101Z" fill="#22398E"/>
				<path id="Vector_11" d="M196.779 320.759H192.161V315.241H207.815V320.759H203.197V336.187H196.779V320.759Z" fill="#22398E"/>
				<path id="Vector_12" d="M212.507 328.979C213.971 330.443 215.885 331.344 217.687 331.344C218.626 331.344 219.301 330.781 219.301 330.068C219.301 329.279 218.776 328.566 216.036 327.965C212.507 327.177 209.842 325 209.842 321.622C209.842 317.793 212.995 314.902 217.274 314.902C219.977 314.902 222.642 315.916 224.632 317.568L221.704 321.922C220.315 320.796 218.851 319.97 217.537 319.97C216.786 319.97 216.261 320.458 216.261 321.059C216.261 321.734 216.674 322.372 219.039 322.898C223.093 323.836 225.72 326.051 225.72 329.542C225.72 333.408 222.567 336.486 217.575 336.486C214.159 336.486 211.418 335.248 209.429 333.183L212.507 328.979Z" fill="#22398E"/>
				<path id="Vector_13" d="M231.464 320.759H226.846V315.241H242.5V320.759H237.882V336.187H231.464V320.759Z" fill="#22398E"/>
				<path id="Vector_14" d="M255.713 315.241L262.545 336.187H256.013L255.037 332.508H249.444L248.506 336.187H241.974L248.806 315.241H255.713ZM250.683 327.778H253.836L252.26 321.81L250.683 327.778Z" fill="#22398E"/>
				<path id="Vector_15" d="M264.647 336.187V315.241H272.905C279.061 315.241 283.416 319.595 283.416 325.714C283.416 331.832 279.061 336.187 272.905 336.187H264.647ZM272.305 330.669C275.195 330.669 276.997 328.754 276.997 325.714C276.997 322.673 275.195 320.759 272.305 320.759H271.066V330.669H272.305Z" fill="#22398E"/>
				<path id="Vector_16" d="M289.422 320.759H284.805V315.241H300.458V320.759H295.841V336.187H289.422V320.759Z" fill="#22398E"/>
				<path id="Vector_17" d="M0.494873 347.674H14.4213V352.967H6.91381V355.482H13.7081V360.662H6.91381V363.252H14.7216V368.582H0.494873V347.674Z" fill="#22398E"/>
				<path id="Vector_18" d="M24.5186 361.6C24.5186 362.651 25.3444 363.44 26.4706 363.44C27.5967 363.44 28.4225 362.651 28.4225 361.6V347.674H34.8039V362.088C34.8039 365.917 31.1252 368.92 26.4706 368.92C21.8159 368.92 18.1372 365.917 18.1372 362.088V347.674H24.5186V361.6Z" fill="#22398E"/>
				<path id="Vector_19" d="M45.2766 361.599V368.581H39.0078V347.635H47.4538C51.6955 347.635 54.9988 350.488 54.9988 354.617C54.9988 357.207 53.685 359.309 51.6955 360.511L55.6745 368.581H48.8051L45.727 361.599H45.2766ZM46.5904 357.17C47.8292 357.17 48.7676 356.194 48.7676 354.842C48.7676 353.454 47.8292 352.515 46.5904 352.515H45.3141V357.17H46.5904Z" fill="#22398E"/>
				<path id="Vector_20" d="M68.6628 347.298C75.1569 347.298 80.1118 352.028 80.1118 358.109C80.1118 364.228 75.1569 368.92 68.6628 368.92C62.1688 368.92 57.2139 364.19 57.2139 358.109C57.2139 352.028 62.1688 347.298 68.6628 347.298ZM68.6628 363.44C71.5532 363.44 73.7304 361.15 73.7304 358.109C73.7304 355.069 71.5908 352.779 68.6628 352.779C65.7724 352.779 63.5953 355.069 63.5953 358.109C63.5953 361.187 65.7349 363.44 68.6628 363.44Z" fill="#22398E"/>
				<path id="Vector_21" d="M89.7212 362.2V368.581H83.3398V347.635H91.7858C96.0651 347.635 99.3309 350.788 99.3309 354.918C99.3309 359.047 96.0651 362.2 91.7858 362.2H89.7212ZM90.8474 357.358C92.1612 357.358 93.0996 356.344 93.0996 354.918C93.0996 353.529 92.1612 352.515 90.8474 352.515H89.7588V357.358H90.8474Z" fill="#22398E"/>
				<path id="Vector_22" d="M112.77 347.674L119.601 368.62H113.07L112.094 364.941H106.501L105.562 368.62H99.0308L105.863 347.674H112.77ZM107.739 360.174H110.893L109.316 354.205L107.739 360.174Z" fill="#22398E"/>
				<path id="Vector_23" d="M123.956 361.375C125.42 362.839 127.334 363.74 129.136 363.74C130.074 363.74 130.75 363.177 130.75 362.464C130.75 361.675 130.224 360.962 127.484 360.361C123.956 359.573 121.29 357.396 121.29 354.018C121.29 350.189 124.444 347.298 128.723 347.298C131.426 347.298 134.091 348.312 136.08 349.964L133.152 354.318C131.763 353.192 130.299 352.366 128.986 352.366C128.235 352.366 127.709 352.891 127.709 353.454C127.709 354.093 128.122 354.768 130.487 355.294C134.541 356.232 137.169 358.447 137.169 361.938C137.169 365.804 134.016 368.92 129.023 368.92C125.607 368.92 122.867 367.681 120.877 365.617L123.956 361.375Z" fill="#22398E"/>
				<path id="Vector_24" d="M155.487 355.181H156.425L159.654 347.674H166.373L161.643 357.847L167.424 368.582H160.705L156.651 360.662H155.487V368.582H149.068V347.674H155.487V355.181Z" fill="#22398E"/>
				<path id="Vector_25" d="M181.914 347.674L188.745 368.62H182.214L181.238 364.941H175.645L174.706 368.62H168.175L175.007 347.674H181.914ZM176.884 360.174H180.037L178.46 354.205L176.884 360.174Z" fill="#22398E"/>
				<path id="Vector_26" d="M190.848 347.674H197.83L202.522 359.798V347.674H208.303V368.582H201.321L196.628 356.458V368.582H190.848V347.674Z" fill="#22398E"/>
				<path id="Vector_27" d="M212.657 368.581V347.635H220.915C227.071 347.635 231.426 351.952 231.426 358.108C231.426 364.227 227.109 368.581 220.915 368.581H212.657ZM220.315 363.101C223.205 363.101 225.007 361.186 225.007 358.146C225.007 355.105 223.205 353.191 220.315 353.191H219.076V363.101H220.315Z" fill="#22398E"/>
				<path id="Vector_28" d="M241.148 368.582H234.729V347.674H241.148V368.582Z" fill="#22398E"/>
				<path id="Vector_29" d="M245.427 368.581V347.635H253.686C259.842 347.635 264.196 351.952 264.196 358.108C264.196 364.227 259.842 368.581 253.686 368.581H245.427ZM253.085 363.101C255.976 363.101 257.777 361.186 257.777 358.146C257.777 355.105 255.976 353.191 253.085 353.191H251.846V363.101H253.085Z" fill="#22398E"/>
				<path id="Vector_30" d="M278.536 347.674L285.367 368.62H278.836L277.86 364.941H272.267L271.328 368.62H264.797L271.629 347.674H278.536ZM273.468 360.174H276.621L275.045 354.205L273.468 360.174Z" fill="#22398E"/>
				<path id="Vector_31" d="M289.422 353.154H284.805V347.674H300.458V353.154H295.841V368.582H289.422V353.154Z" fill="#22398E"/>
			</g>
			<g class="alpha-transition" class:hideFive id="five" transform="translate(234, 72.5)">
				<line class:drawFive class="st0" x1="0" y1="26" x2="65.9" y2="26" fill="none"/>
				<path class:drawFive class="st0" d="M0,91.5h17.9c25.9,0,46.9,21,46.9,46.9v0c0,25.9-21,46.9-46.9,46.9H0" fill="none"/>
			</g>
			<g class="alpha-transition" class:hideZero id="colored_center_item">
				<circle id="white_back" cx="134" cy="213" r="73" fill="white"/>
				<g class="rotation rotation--clockwise" id="c" class:rotate>
					<path id="Vector_34" d="M155.412 231.608L146.441 224.062C143.513 227.554 139.384 229.693 134.842 230.106C130.337 230.557 125.87 229.093 122.342 226.165L112.845 237.463L109.391 241.593C116.148 247.261 124.519 250.301 133.265 250.301C134.354 250.301 135.48 250.264 136.568 250.151C140.773 249.776 144.789 248.575 148.543 246.885C153.61 244.596 158.19 241.33 161.869 236.975L155.412 231.608Z" fill="#008B60"/>
					<path id="Vector_35" d="M120.202 202.065C123.13 198.574 127.259 196.435 131.801 196.022C136.381 195.609 140.81 197.035 144.301 199.963L157.252 184.535C149.631 178.154 139.947 175.076 130.074 175.977C120.652 176.803 112.131 181.157 105.825 188.139C105.487 188.477 105.112 188.777 104.812 189.152L120.202 202.065Z" fill="#5A97C3"/>
					<path id="Vector_36" d="M104.774 189.152C101.058 193.581 98.6927 198.649 97.3414 203.904C93.963 217.305 98.0546 232.132 109.353 241.592L112.807 237.463L122.304 226.164C115.097 220.083 114.158 209.272 120.202 202.065L104.774 189.152Z" fill="#D60059"/>
				</g>
				<g class="rotation rotation--reverseclockwise" id="outer_ring" class:rotate>
					<path id="Vector_37" d="M167.365 241.104C162.936 246.397 157.418 250.189 151.487 252.816C136.772 259.273 119.054 257.508 105.916 246.472L90.8633 264.415C103.401 274.926 118.679 280.069 133.881 280.069C153.026 280.069 172.02 271.923 185.27 256.157L167.365 241.104Z" fill="#22398E"/>
					<path id="Vector_38" d="M200.698 207.245C199.647 195.383 195.518 184.31 188.874 174.775C185.533 170.008 181.592 165.578 177.012 161.712L161.959 179.655C168.303 184.985 172.808 191.892 175.323 199.587C176.336 202.703 177.087 205.894 177.387 209.235C178.401 220.834 174.835 232.133 167.365 241.066L185.308 256.119C192.778 247.223 197.658 236.75 199.76 225.639C200.886 219.67 201.261 213.476 200.698 207.245Z" fill="#F07F57"/>
					<path id="Vector_39" d="M82.605 170.008L100.548 185.06C101.036 184.46 101.637 184.047 102.162 183.521C117.853 166.667 144.167 164.715 161.997 179.692L177.05 161.749C168.754 154.805 159.219 150.263 149.347 147.935C148.108 147.635 146.907 147.372 145.668 147.185C132.08 144.82 118.003 146.734 105.465 152.59C96.8693 156.532 89.0239 162.312 82.605 170.008Z" fill="#C9468A"/>
					<path id="Vector_40" d="M82.6049 170.008C69.5043 185.623 64.8121 205.518 67.9277 224.212C70.4803 239.415 78.1755 253.792 90.8632 264.453L105.916 246.51C92.8527 235.549 88.0104 218.506 91.7266 202.928C93.2656 196.547 96.0434 190.428 100.548 185.06L82.6049 170.008Z" fill="#EBC851"/>
				</g>
			</g>
			<path class="alpha-transition" class:hideHeadline id="chemnitz" d="M22.529 42.7554C28.4599 42.7554 33.7903 40.7659 37.8443 37.2373L31.9134 29.1292C29.5485 31.3439 26.1326 33.0707 22.529 33.0707C16.1476 33.0707 11.3052 28.0406 11.3052 21.3965C11.3052 14.7523 16.1476 9.72225 22.529 9.72225C26.2077 9.72225 29.2482 11.2988 31.5756 13.3259L37.2813 5.14266C33.3023 1.87688 28.3098 0 22.529 0C9.80373 0 0.0439453 9.34687 0.0439453 21.3589C0.0439453 33.4085 9.80373 42.7554 22.529 42.7554ZM43.7753 42.0422H54.9991V26.0887H66.448V42.0422H77.6718V0.713215H66.448V16.4415H54.9991V0.713215H43.7753V42.0422ZM87.0562 42.0422H114.534V32.6577H98.28V25.8634H112.582V16.6667H98.28V10.0976H113.971V0.713215H87.0562V42.0422ZM148.092 30.2929L155.3 15.916V42.0422H165.585V0.713215H152.897L144.151 18.2058L135.405 0.713215H122.717V42.0422H133.002V15.916L140.209 30.2929H148.092ZM175.007 42.0422H185.292V16.8919L196.854 42.0422H208.903V0.713215H198.618V25.8634L187.056 0.713215H175.007V42.0422ZM218.325 0.713215V42.0422H229.549V0.713215H218.325ZM244.376 42.0422H255.6V10.3604H265.247V0.713215H234.729V10.3604H244.376V42.0422ZM269.414 33.2583V42.0422H300.232V32.395H282.702L299.632 9.49702V0.713215H270.315V10.3604H286.344L269.414 33.2583Z" fill="#22398E"/>
		</g>
	</svg>
	<Arrow/>
	<Subline/>
</div>

